import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import skTranslations from './locales/sk.json';
import czTranslations from './locales/cz.json';

const isBrowser = typeof window !== 'undefined';
const supportedLangs = ['en', 'sk', 'cz'];
const getInitialLang = () => {
  if (!isBrowser) return undefined;
  const pathLang = window.location.pathname.split('/')[1];
  return supportedLangs.includes(pathLang) ? pathLang : 'cz';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      sk: {
        translation: skTranslations,
      },
      cz: {
        translation: czTranslations,
      },
    },
    fallbackLng: 'cz',
    debug: true,
    lng: getInitialLang(),
    initImmediate: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
